import React, { Component } from 'react'
import { connect } from 'react-redux'
import { languageSwitchItem } from '../actions/locales'

import { bindActionCreators } from 'redux'

import i18next from 'i18next'

import Body from '../components/body/Body'
import Login from './Login'

class BodyContainer extends Component {

	componentDidMount() {
		
	}

	render() {
		return (
			<div className={this.props.base.fontSize !== 0 ? "visual-impairment-content-font-size-" + this.props.base.fontSize : null}>
				{
					this.props.base.authEnabled === "true" && !this.props.base.isLoggedIn
					? <Login />
					: <Body connectionStatus={this.props.connectionStatus} />
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        locales: state.i18n,
        localesReducer: state.localesReducer,
        base: state.base,
        mobileModeReducer: state.mobileModeReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    languageSwitchItem
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BodyContainer);